import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[y42StopPropagation]',
  standalone: true,
})
export class StopPropagationDirective {
  @HostListener('click', ['$event'])
  onClick(e: MouseEvent) {
    e.stopPropagation();
  }
}
